module.exports = __webpack_public_path__ + "static/media/washingtonpost.com_news_the-switch_wp_2016_06_24_the-british-are-frantically-googling-what-the-eu-is-hours-after-voting-to-leave-it__plot.04677886.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/washingtonpost.com_news_the-switch_wp_2016_06_24_the-british-are-frantically-googling-what-the-eu-is-hours-after-voting-to-leave-it__plot.png
// module id = 435
// module chunks = 0